@use '~/theme/theme' as *;

.root {
  height: 100vh;
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  gap: spacing(2);
  align-items: center;
  justify-content: center;
  background-color: white;
}

.logo {
  height: 64px;
  width: auto;
  z-index: 2;
}

.progress {
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  top: 50%;
  margin-top: spacing(-8);
  color: color(grey-300);
}
